import React from "react";
import { NavLink } from "react-router-dom";
import { withAlert } from "react-alert";
import { withTranslation } from "react-multi-lang";
import {
    Silentauditobject, Servicecalls, Getuserprojectfromsession,
    Getuserworkflowfromsession,
    orderTypeforprotocol,
    onGetUserControlRights
} from "./../custom_functions/Functions.jsx";
import store from "../redux_store/store/index";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CustomButtonCell } from "./columnMenu.jsx";
import { MyGlobalContext } from "../custom_modules/orders/Sheetorder";
import $ from "jquery";
import {
    Shareorderforprotocol,
    Downloadfile,
    Deletefile,
    Viewfile,
    EditFile
} from "../custom_functions/ManipulationFunction";
import {
    Customprotocolordercells
} from "./CustomDetailviewCell";
import { isMultitenant } from "../custom_functions/Constance.jsx";

let rights;
class PendingprotocolorderViewCell extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            controlRights: onGetUserControlRights("Protocol")
        };
    }

    componentDidMount() {
        this._isMounted = true;
        const controlRights = onGetUserControlRights("Protocol");
        this.setState({ controlRights });
        rights = this.context;
    }

    onbuttonclick(e) {

        let passObjDet = {
            objsilentaudit: Silentauditobject(
                "copy",
                "Protocol Orders",
                this.props.t("Orders.Protocolorders.IDS_AUDIT_COPYORDER", {
                    screen: orderTypeforprotocol(this.props.dataItem.protocoltype),
                    batchid: this.props.dataItem.directoryname,
                    user: store.getState().Loggeduser.username
                })
            ),
        };
        Servicecalls(
            "" + window.appUrl.ELN + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
        );
        this.props.alert.success(this.props.t("Orders.Protocolorders.IDS_MSG_COPYLINK", {
            batchid: this.props.dataItem.directoryname,
            screenname: isMultitenant === 2 ? this.props.t("Dashboard.IDS_LBL_TASK") :
                this.props.t("Dashboard.IDS_LBL_ORDER")
        }));
    }

    onAuditValidateError(res) { }

    onAuditValidateFailure(res) { }

    setClickPopover(e, event) {
        this.setState({
            popOverLeft: e.clientX,
            popOverTop: e.clientY,
            eventKey: event === this.state?.eventKey ? false : event
        })
    }
    handleMouseOut = () => {
        let body = document.getElementsByClassName("modal-open");
        if (!body.length) {
            this.setState({
                eventKey: false
            })
        }
    };

    onbuttonclick1(values) {
        this.props.onclick(JSON.parse(values), this.props.field);
    }

    onUnShareClick = (event, item) => {
        this.props.openunsharelist(item);
    };

    render() {
        const { controlRights } = this.state;
        return (
            <td onMouseLeave={this.handleMouseOut} className={`k-grid-content-sticky k-command-cell pl-0 stickyaction`}>
                {this.props.dataItem[this.props.keyfield] !== undefined ? (
                    <div className="actionsBtn 1 flex-centered padd-actionsBtn pr-2">
                        {
                            $.session.get("Username") === "Administrator" ? ("") : (
                                <div className="processOrderBtn 1 no-margin-process rejectColm">
                                    <CustomButtonCell
                                        {...this.props}
                                        keyfield={this.props.keyfield}
                                        onclick={this.props.onorderopen}
                                        screen={"Protocol"}
                                    />
                                </div>
                            )
                        }
                        {
                            (this.props.dataItem.order.ordercancell === undefined || this.props.dataItem.order.ordercancell === 0) ?
                                <div className="group-hover-icon">
                                    <button className="" style={{ backgroundColor: "transparent", color: "#1970eb", border: "0" }} onClick={(event) => this.setClickPopover(event, this.props.dataItem.order.protoclordername)}><i className="fa fa-ellipsis-v"></i></button>
                                    {this.state?.eventKey === this.props.dataItem.order.protoclordername &&
                                        <div className="list-view-btn-group" style={{ "left": this.state.popOverLeft, "top": this.state.popOverTop }}>
                                            {controlRights?.clone &&
                                                <li>
                                                    <button id="cancel_order" title={"Dublicate Order"} className="grid-icons" onClick={(event) => this.props.onordercommonaction(this.props.dataItem, "duplicate")}>
                                                        <i className="fas fa-clone" aria-hidden="true" title="Clone"></i>
                                                    </button>
                                                </li>
                                            }

                                            {controlRights.copy &&
                                                // <CopyToClipboard text={this.props.dataItem["link"]}>
                                                <button title="copy link" className="grid-icons"
                                                    onClick={() => {
                                                        const valueToCopy = this.props.dataItem["link"];
                                                        if (navigator.clipboard && navigator.clipboard.writeText) {
                                                            navigator.clipboard.writeText(valueToCopy).then(() => {
                                                                console.log("Copied to clipboard!");
                                                            }).catch((err) => {
                                                                console.error("Failed to copy:", err);
                                                            });
                                                        } else {
                                                            const textarea = document.createElement("textarea");
                                                            textarea.value = valueToCopy;
                                                            document.body.appendChild(textarea);
                                                            textarea.select();
                                                            try {
                                                                document.execCommand("copy");
                                                                console.log("Copied using fallback!");
                                                            } catch (err) {
                                                                console.error("Fallback copy failed:", err);
                                                            }
                                                            document.body.removeChild(textarea);
                                                        }
                                                        this.onbuttonclick();
                                                    }}
                                                >
                                                    {/* <i className="fas fa-copy"></i> */}
                                                    <svg style={{ width: "17px" }} fill="none" viewBox="0 0 16 16" role="presentation" className="_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31 _1bsbpxbi _4t3ipxbi"><path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"></path></svg>
                                                </button>
                                                // </CopyToClipboard>
                                            }

                                            {controlRights.share && <Shareorderforprotocol
                                                {...this.props}
                                                keyfield={this.props.keyfield}
                                                isshared={false}
                                                props={this.props}
                                                passbackorder={this.props.passbackorder}
                                            />}
                                            {this.props.dataItem.order !== undefined &&
                                                this.props.dataItem.order.sharebyme !== undefined &&
                                                this.props.dataItem.order.sharebyme !== null && this.props.dataItem.order.sharebyme.length > 0 &&
                                                (<button title={"Unshare"} className="btn grid-icons" onClick={event => this.onUnShareClick(event, this.props.dataItem.order)}>
                                                    <span className="fa-stack fa-sm fa-stack-size">
                                                        <i className="fa fa-share-alt fa-stack-1x"></i>
                                                        <i className="fa fa-ban  fa-stack-2x"></i>
                                                    </span>
                                                </button>)}
                                            <Customprotocolordercells
                                                {...this.props}
                                                keyfield={this.props.keyfield}

                                            />
                                            <NavLink
                                                className="grid-icons"
                                                target="_blank"
                                                onClick={(e) => {
                                                    // if (this.props.dataItem.ordercancell !== undefined && this.props.dataItem.ordercancell === 1) {
                                                    //   this.props.alert.error(this.props.t("Orders.Protocolorders.IDS_LBL_CANCELLORDEROPEN"));
                                                    //   e.preventDefault()

                                                    // } else {
                                                    let order = this.props.dataItem.order;
                                                    order.isprotocolprocess = true;
                                                    let projects = Getuserprojectfromsession();
                                                    let workflow = Getuserworkflowfromsession();
                                                    order.lstproject = projects;
                                                    order.lstworkflow = workflow;
                                                    let passdata = {
                                                        order: order,
                                                        user: store.getState().Loggeduser,
                                                        activekey: this.props.activekey,
                                                        protocolorderopen: true,
                                                        screen: "Protocol",
                                                        multiusergroups: sessionStorage.multiusergroups,
                                                        tenantid: sessionStorage.getItem("tenantid"), token: sessionStorage.getItem("Token"),
                                                        loginTime: sessionStorage.getItem("LoginTime"), loggedfrom: sessionStorage.getItem("loggedfrom"),
                                                        azuretoken: sessionStorage.getItem("azuretoken"), tenantdomain: sessionStorage.getItem("tenantdomain"),
                                                        userpasscodeencrypted: sessionStorage.userpasscodeencrypted,
                                                        packagetype: isMultitenant === 0 ? "3" : sessionStorage.getItem("packagetype"),
                                                        teamusercode: sessionStorage.getItem("teamusercode"),
                                                        Protocol_Userworkflows: sessionStorage.getItem("Protocol_Userworkflows"),
                                                        idletime: sessionStorage.idletime
                                                    };
                                                    localStorage.setItem("linkedorder", JSON.stringify(passdata));
                                                    // }

                                                }}
                                                to={{
                                                    pathname: "/vieworder",
                                                    state: { order: this.props.dataItem.order, rights: rights },

                                                }}
                                            >
                                                <i className="fa fa-external-link-alt"></i>
                                            </NavLink>
                                            {controlRights.cancel && this.props.dataItem.order.canuserprocess && this.props?.dataItem?.order?.orderflag !== "R" ?
                                                <React.Fragment>
                                                    <button title={isMultitenant === 2 ? "Cancel Task" : "Cancel Order"} className="grid-icons new-close" onClick={(event) => this.props.onordercommonaction(this.props.dataItem)}>
                                                        {/* <svg fill="#0e5bca" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" /></svg> */}
                                                        <i className="fa fa-times" aria-hidden="true"></i>
                                                    </button>
                                                </React.Fragment> : false
                                            }
                                            {this.props.dataItem?.order?.isclone !== true && (this.props.dataItem?.order?.lsautoregister?.repeat === false ? false : (this.props.dataItem?.order?.repeat && this.props.dataItem?.order?.sharetome === undefined) || (this.props.dataItem?.order?.repeat && this.props.dataItem?.order?.sharetome !== undefined && this.props.dataItem?.order?.sharetome?.some((items) => items.sharerights === 1))) ?
                                                <React.Fragment>

                                                    <button title="Stop auto" className="grid-icons stop" onClick={(event) => this.stopautoregister(event, this.props.dataItem)}
                                                    >
                                                        <i className="synccancel" aria-hidden="true"></i>
                                                    </button>
                                                </React.Fragment> : false
                                            }
                                        </div>
                                    }
                                </div>
                                : <Customprotocolordercells
                                    {...this.props}
                                    keyfield={this.props.keyfield}

                                />
                        }
                    </div>
                ) : (
                    this.props.dataItem !== undefined && this.props.dataItem.file !== undefined &&
                    <div className="actionsBtn 2 align-items-center ">
                        <Downloadfile file={this.props.dataItem.file}
                            url={this.props.filedownloadurl} />

                        <Deletefile
                            file={this.props.dataItem.file}
                            ondeletefile={this.props.ondeletefile} />

                        <Viewfile
                            file={this.props.dataItem.file}
                            url={this.props.filedownloadurl} screen={this.props.screen} />

                        {(this.props.dataItem?.file?.filename?.endsWith(".docx") || this.props.dataItem?.file?.filename?.endsWith(".xlsx")) &&
                            <EditFile
                                file={this.props.dataItem.file}
                                url={this.props.filedownloadurl} screen={this.props.screen} />
                        }
                    </div>
                )}
            </td>
        );
    }
}
PendingprotocolorderViewCell.contextType = MyGlobalContext;
export default withAlert()(withTranslation(PendingprotocolorderViewCell));
